'use client';

import { Suspense } from 'react';
import { useTranslations } from 'next-intl';
import { ShapkaVhoda } from '@/components/features/shapka-vhoda';
import { useSearchParams } from 'next/navigation';
import { KeyRound } from 'lucide-react';
import { Link } from '@/i18n/routing';
import { FlowForm } from '@/components/features/flow-form';
import { putVozvrata } from '@/lib/vozvrat-posle-vhoda';

function RecoverCard() {
  const t = useTranslations('recover');
  const tl = useTranslations('login');
  const searchParams = useSearchParams();
  const syroj = searchParams.get('callbackUrl');
  const callbackUrl = putVozvrata(syroj);

  return (
    <div className="w-full max-w-md">
      <div className="bg-[var(--color-bg-card)] border border-[var(--color-border)] rounded-2xl p-8 shadow-xl">
        <div className="text-center mb-8">
          <ShapkaVhoda znachok={<KeyRound className="w-6 h-6 text-[var(--color-brand-400)]" />} />
          <p className="text-[var(--color-text-muted)]">{t('subtitle')}</p>
        </div>

        <FlowForm kind="recovery" callbackUrl={callbackUrl} />

        <div className="mt-6 pt-6 border-t border-[var(--color-border)] text-center text-sm">
          <Link
            href={syroj ? { pathname: '/login', query: { callbackUrl } } : '/login'}
            className="text-[var(--color-text-muted)] hover:text-[var(--color-accent-400)] transition-colors"
          >
            {t('back_to_login')}
          </Link>
        </div>

        <p className="text-xs text-[var(--color-text-muted)] text-center mt-6">{tl('footer')}</p>
      </div>
    </div>
  );
}

export default function RecoverPage() {
  return (
    <main className="min-h-[calc(100vh-4rem)] flex flex-col items-center justify-center p-8">
      <Suspense fallback={null}>
        <RecoverCard />
      </Suspense>
    </main>
  );
}
